import { captureMessage } from '@sentry/react';
import type { Context } from '@sentry/types/types/context';

export const logger = {
  log: (message: string, data?: Context) => captureMessage(message, { level: 'log', contexts: { data } }),
  error: (message: string, data?: Context) => captureMessage(message, { level: 'error', extra: { data, dataString: JSON.stringify(data) } }),
};
